<template>
  <div>
    <app-header></app-header>
    <app-main></app-main>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from './components/header/Header.vue'
import Footer from './components/footer/Footer.vue'
import Main from './components/main/Main.vue'

export default {
  components: {
    appHeader: Header,
    appMain: Main,
    appFooter: Footer
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize () {
      this.$store.dispatch('setWidth')
    }
  }
}
</script>

<style>

</style>
